import { render, staticRenderFns } from "./password.vue?vue&type=template&id=1d20871a&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=1d20871a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20871a",
  null
  
)

export default component.exports